import { render, staticRenderFns } from "./QualityHistoryTable.vue?vue&type=template&id=1560cd98&scoped=true&"
import script from "./QualityHistoryTable.vue?vue&type=script&lang=js&"
export * from "./QualityHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./QualityHistoryTable.vue?vue&type=style&index=0&id=1560cd98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1560cd98",
  null
  
)

export default component.exports